<i18n lang='yml' src='../i18n/Stepper.yml'></i18n>

<template>
  <nav class="stepper-wrapper" id="stepper-wrapper" v-if="showStepper()">
    <a v-for="(step, index) in filteredSteps" :key="step.step" class="stepper-item" :class="applyStatus(index, step)" href="#" @click.prevent="handleStepClick(step)">
      <span class="step-bubble">
        <span v-if='isCompleted(step)'><font-awesome-icon :icon="['fa', 'check']" /></span>
      </span>
      <span class="step-name">{{ $t(`${step.name}`) }}</span>
    </a>
  </nav>
</template>
<script>

export default {
  props: ['activeStep', 'includeAccommodation', 'type', 'admin'],

  data() {
    return {
      steps: [
        {pos: 0, name: 'exam_type', step: 'exam-type'},
        {pos: 1, name: "accommodation", step: "accommodation"},
        {pos: 2, name: "sitting", step: "sitting"},
        {pos: 3, name: "review", step: "review"},
        {pos: 4, name: "confirmation", step: "confirmation"},],
        
      selectedUser: null,
    }
  },

  computed: {
    filteredSteps() {
      return this.admin == 'false'
        ? this.steps.filter(step => step.name !== 'accommodation')
        : this.steps
    }
  },

  methods: {
    showStepper() {
      return this.steps.filter(step => step.step == this.activeStep).length > 0
    },
    getCurrentIndex() {
       return this.steps.map(e => e.step).indexOf(this.activeStep);
    },
     applyStatus(index, step) {
      let currentIndex = this.getCurrentIndex()
      if (index == currentIndex ) {
        return "active"
      } else if (this.isDisabled(step)) {
        return "disabled"     
      } else if (index < currentIndex ) {
        return "completed"
      }
     },
    handleStepClick(step) { 
      if(this.activeStep != 'confirmation') {
        let currentIndex = this.getCurrentIndex()
        if (step.pos < currentIndex) {   
          this.$emit('stepClicked', step.step)
        }
      }
    },

    isDisabled(step) {
      return (step.step == 'accommodation' && !this.includeAccommodation) || (step.step == 'exam-type' && this.type == 'edit')
    },

    isCompleted(step) {
      let currentIndex = this.getCurrentIndex()
      if (step.pos < currentIndex && !this.isDisabled(step)) {   
        return true
      }
    }

  }
}
</script>

